import React from 'react';
import {RootNavigator} from '@/navigation/RootNavigation';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {store, persistor} from '@/services/redux/store';
import '@/stylesheet';
import {ToastProvider, ConfirmationModalProvider, WebSocketProvider} from '@/context';
import {AppSettings} from './AppSettings';
import { HelmetProvider } from "react-helmet-async";


const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider>
          <ConfirmationModalProvider>
            <AppSettings>
              <HelmetProvider>
                <WebSocketProvider>
                  <RootNavigator />
                </WebSocketProvider>
              </HelmetProvider>
            </AppSettings>
          </ConfirmationModalProvider>
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
